import React from 'react';
import './AppLoader.scss';

const AppLoader = ({display}) => {

    return (
        <div className={`loader ${display ? 'show' : 'hide-loader' }`} />

    )

};

export default AppLoader;
